<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-title top-margin">Documents</div>
      <div class="line-separator"></div>
      <DocumentTabView />
    </div>
  </div>
</template>

<script>
import { logAction } from '@/util';
import logActions from '@/data/static/logActions';
import { mapState } from 'vuex';
import spinner from '@/components/widgets/Spinner';
import DocumentTabView from '@/components/DocumentTabView/DocumentTabView';

export default {
  name: 'AdminAccountDocuments',
  data() {
    return {};
  },
  methods: {
    logDocumentViewed(key) {
      const logMessage = `User U${this.user.id} viewed ${key} document`;
      logAction({
        user: this.user.id,
        level: 'info',
        action: logActions.DOCUMENT_VIEW.name,
        message: logMessage,
      });
    },
  },
  computed: {
    ...mapState('app', ['user']),
  },
  components: {
    spinner,
    DocumentTabView,
  },
};
</script>

<style scoped>
  .panel-title {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .panel-default {
    padding: 30px 40px;
  }
  
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// AdminAccountDocuments.vue?e2eaf13a